/* eslint-disable no-param-reassign */
/* eslint-disable react/prop-types */
import { React, classNames } from '@digsup/core-ui';
import { toast as toastifyToast, ToastContainer } from 'react-toastify';
import Transition from 'react-transition-group/Transition';
import { Button } from '@digsup/components-button';
import { Icon } from '@digsup/components-icon';
import { styles } from './Toast.scss';

const cx = classNames.bind(styles);

toastifyToast.configure();

// eslint-disable-next-line no-unused-vars
const RevealTransition = ({
  children,
  nodeRef,
  done,
  preventExitTransition,
  isIn,
  ...props
}) => {
  const onEnter = () => {
    const node = nodeRef.current;
    const toastBodyDimensions = node.firstChild.getBoundingClientRect();
    node.style.setProperty('--toast-width', `${node.clientWidth}px`);
    node.style.setProperty(
      '--toast-body-width',
      `${toastBodyDimensions.width}px`,
    );
    node.style.setProperty(
      '--toast-body-height',
      `${toastBodyDimensions.height}px`,
    );
    node.classList.add('Toastify--enter', 'Toastify--animate');
  };

  const onExit = () => {
    const node = nodeRef.current;
    node.classList.add('Toastify--exit', 'Toastify--animate');
    node.classList.remove('Toastify--enter', 'Toastify--animate');
  };

  return (
    <Transition
      {...props}
      unmountOnExit
      nodeRef={nodeRef}
      timeout={{
        enter: 500,
        exit: preventExitTransition ? 0 : 550,
      }}
      onEnter={onEnter}
      onExit={preventExitTransition ? done : onExit}
      onExited={done}
      appear
      in={isIn}>
      {children}
    </Transition>
  );
};

const CloseButton = ({ closeToast, onClose }) => (
  <Button
    size="small"
    variant="flat"
    iconOnly
    icon={<Icon name="x" size="small" />}
    className="Toastify__close-button"
    onClick={() => {
      closeToast();
      onClose?.();
    }}>
    Close
  </Button>
);

// eslint-disable-next-line prettier/prettier
const Container = props => <div>{props.children}</div>;

export { toastifyToast as toastControl, ToastContainer };

export const toast = (children, options = {}) => {
  const {
    autoClose = 2500,
    theme = 'positive',
    onOpen = null,
    onClose = null,
    ...restOptions
  } = options;

  return toastifyToast(<Container>{children}</Container>, {
    position: toastifyToast.POSITION.TOP_CENTER,
    closeButton: !autoClose ? <CloseButton onClose={onClose} /> : false,
    draggable: true,
    draggablePercent: 60,
    transition: RevealTransition,
    autoClose,
    closeOnClick: true,
    onOpen,
    onClose,
    className: cx({
      [`t-${theme}`]: theme,
      'Toastify__toast--with-close-btn': !autoClose,
    }),
    ...restOptions,
  });
};
